import React, { useState, useEffect, useContext } from 'react'
import { QuestionContext } from '../../../../Context'
import { Answer, Question } from '../../../../Api'
import { AnswerItem, PercentCon } from '../../styles'
import { shouldShowPercent } from '../../../../Utils'
import { Img } from '../../../Image/Img'

type QuestionProps = {
  question: Question
  correct: number
  answer: Answer
  isSelected: boolean
  calculatePercentage: (answerCount: number) => string
  onSelect: (sel: string) => void
  uiTheme?: 'light' | 'dark'
}

export const MultiChoiceAnswerRow: React.FC<React.PropsWithChildren<QuestionProps>> = ({
  question,
  correct,
  answer,
  isSelected,
  calculatePercentage,
  uiTheme,
  onSelect,
}) => {
  const { questions } = useContext(QuestionContext)!
  const [shouldShowPct, setShouldShowPct] = useState<boolean>(false)
  const [pct, setPct] = useState<string>(calculatePercentage(answer.count))

  useEffect(() => {
    let pct = calculatePercentage(answer.count)
    setPct(pct)
    checkShowing()
  }, [questions])

  useEffect(() => {
    let pct = calculatePercentage(answer.count)
    setPct(pct)
    checkShowing()
  }, [])

  const checkShowing = () => {
    const show = shouldShowPercent(question)
    setShouldShowPct(show)
  }

  return (
    <AnswerItem
      uiTheme={uiTheme}
      correct={correct}
      selected={isSelected}
      onClick={() => {
        onSelect(answer.code)
      }}
    >
      <div className="answerCon">
        {answer.image && <Img src={answer.image} alt={`Image for ${answer.value}`} />}
        <div className="answerTextCon">
          <div className="answerText">{answer.value}</div>
          {answer.extraText && <div className="extraText">{answer.extraText}</div>}
        </div>
      </div>
      {shouldShowPct && (
        <PercentCon uiTheme={uiTheme} correct={correct} selected={isSelected}>
          {pct}%
        </PercentCon>
      )}
    </AnswerItem>
  )
}
